import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { Logo } from "./Logo";
import Magnetic from "./motion/Magnetic";

const LINKS = [
  ["About", "/about", "about"],
  ["Programmes", "/programs", "programs"],
  ["Membership", "/membership", "membership"],
  ["Contact", "/contact", "contact"],
];

export default function Footer() {
  const c = useContent();
  return (
    <footer className="relative overflow-hidden bg-ink text-[#CFE3D9]" data-testid="site-footer">
      <img
        src="/brand/leaf.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-24 h-[520px] w-[520px] object-contain opacity-[0.08]"
      />
      <div className="relative mx-auto max-w-[1200px] px-5 pb-8 pt-16 md:pt-20">
        <div className="grid gap-12 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-7">
            <img src="/brand/lockup-light.png" alt="Veridian Education Foundation" className="w-full max-w-[320px]" />
            <p
              className="mt-6 font-display text-2xl font-medium leading-snug text-white md:text-3xl"
              data-testid="footer-tagline"
            >
              {c.get("footer", "tagline")}
            </p>
            <Magnetic strength={0.3}>
              <Link
                to="/contact"
                data-testid="footer-cta"
                className="btn-sweep mt-8 inline-flex items-center gap-2 rounded-md bg-terra px-[1.35rem] py-[0.8rem] font-display text-[0.98rem] font-semibold text-ink transition-transform duration-500 hover:-translate-y-0.5"
              >
                Start a conversation <ArrowUpRight className="h-4 w-4" />
              </Link>
            </Magnetic>
          </div>
          <div className="md:col-span-2 md:col-start-9">
            <p className="font-display text-xs font-semibold uppercase tracking-[0.16em] text-mintlight">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map(([label, to, id]) => (
                <li key={id}>
                  <Link
                    className="link-line transition-colors hover:text-white"
                    to={to}
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-display text-xs font-semibold uppercase tracking-[0.16em] text-mintlight">Contact</p>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a
                  href={`mailto:${c.get("contact_info", "email")}`}
                  className="link-line transition-colors hover:text-white"
                  data-testid="footer-email"
                >
                  {c.get("contact_info", "email")}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${c.get("contact_info", "phone").replace(/\s/g, "")}`}
                  className="link-line transition-colors hover:text-white"
                  data-testid="footer-phone"
                >
                  {c.get("contact_info", "phone")}
                </a>
              </li>
              <li className="text-[0.95rem] leading-relaxed text-mintlight" data-testid="footer-office">
                {c.get("contact_info", "office")}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/15 pt-5 text-sm text-mintlight md:flex-row md:items-center md:justify-between">
          <Logo light />
          <div className="flex items-center gap-8">
            <span data-testid="footer-note">
              © {new Date().getFullYear()} {c.get("footer", "note")}
            </span>
            <Link
              to="/admin/login"
              className="link-line transition-colors hover:text-white"
              data-testid="footer-admin-link"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
